module.exports = __webpack_public_path__ + "img/xm_e.c9f89d36.png";